/**
 * @description This script is used to override the review stars click behavior. Since our reviews are in a disclosure, we need to open the disclosure when the stars are clicked.
 */

function waitForElements(selector, callback, timeout = 10000) {
    const elements = document.querySelectorAll(selector);
    if (elements.length > 0) {
        callback(elements);
        return;
    }

    const observer = new MutationObserver((_, obs) => {
        const elements = document.querySelectorAll(selector);
        if (elements.length > 0) {
            obs.disconnect();
            callback(elements);
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    // Fallback timeout
    setTimeout(() => {
        observer.disconnect();
        const elements = document.querySelectorAll(selector);
        if (elements.length > 0) {
            callback(elements);
        }
    }, timeout);
}

waitForElements('.jdgm-preview-badge--with-link', (stars) => {
    // We are cloning the stars and replacing the original stars with the cloned ones to avoid the default behavior aka remove any event listeners.
    stars.forEach((star) => {
        const newStars = star.cloneNode(true);
        star.parentNode.replaceChild(newStars, star);
    });

    const newStars = document.querySelectorAll('.jdgm-preview-badge--with-link');
    newStars.forEach((star) => {
        new DisclosureOpener(star, 'details-disclosure#disclosure-summary-reviews');
    });
});
